export const iterateNumberArray = (i: number) => Array(i).fill(0).map((x,i)=>i);

export const numberToAlpha = (i: number) => (i < 26)?(i + 9).toString(36).toUpperCase():'NAA';